import { isEmpty } from "lodash";
import { useState } from "react";
import { Button, Card, Form, Image, Spinner } from "react-bootstrap";
import {
  eInteraction,
  StoreInteractionRequest,
} from "../../../@types/Interaction";
import { Post } from "../../../@types/Posts";
import { User } from "../../../@types/Users";
import usePostContext from "../../../context/PostContext";
import useProfilePicture from "../../../hooks/useProfilePicture";
import useInteraction from "../../../hooks/useInteraction";

interface Props {
  post: Post;
  user: User;
  show: boolean;
}

export function AddNewComment({ post, user, show }: Props) {
  const { interactions, setInteractions } = usePostContext();
  const [comment, setComment] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const { getProfilePictureURI } = useProfilePicture();
  const { create } = useInteraction();

  async function handleSubmit(e: React.FormEvent) {
    setErrorMsg("");
    setIsLoading(true);
    e.preventDefault();

    const newInteraction: StoreInteractionRequest = {
      content: comment,
      interactable_id: post.id,
      interactable_type: "post",
      type: eInteraction.COMMENT,
    };

    const createdInteraction = await create(newInteraction);

    if (createdInteraction) {
      const newInteractionsContextState = [
        ...interactions,
        { ...createdInteraction, user },
      ];

      setInteractions(newInteractionsContextState);
      setComment("");
    }

    setIsLoading(false);
  }

  if (!show) {
    return <></>;
  }

  return (
    <Card
      className={isEmpty(interactions) ? "bd-b-0" : ""}
      style={{
        borderTop: "none",
        borderEndEndRadius: 15,
        borderEndStartRadius: 15,
        borderLeftWidth: 0,
        borderRightWidth: 0,
      }}
    >
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <div style={{ display: "flex" }}>
            <Image
              src={getProfilePictureURI(user.profile_picture)}
              className="mg-r-10 img-xs rounded-circle mg-r-5"
              style={{ objectFit: "cover", minWidth: 37, minHeight: 37 }}
            />

            <Form.Control
              type="text"
              value={comment}
              onChange={(e) => {
                const value = e.target.value;

                if (value.length < 100) {
                  setComment(e.target.value);
                  setErrorMsg("");
                } else {
                  setErrorMsg(
                    "O seu comentário excede o tamanho máximo permitido (100 caracteres)"
                  );
                }
              }}
              placeholder="Escreva seu comentário..."
              className="mg-r-5"
            />

            <Button
              variant="primary"
              type="submit"
              style={{ borderRadius: 15 }}
            >
              {isLoading ? <Spinner animation="border" size="sm" /> : "Enviar"}
            </Button>
          </div>
          <div className="text-center">
            {errorMsg && <span style={{ color: "red" }}>{errorMsg}</span>}
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
